{
  "page": {
    "title": "แพ็กเกจ",
    "subtitle": "เลือกแพ็กเกจหรือเพิ่มที่นั่งแอดมินสำหรับร้านของคุณ",
    "orderHistory": "ประวัติการสั่งซื้อ",
    "receiptRequired": "กรุณากรอกข้อมูลใบเสร็จรับเงินก่อนชำระเงิน",
    "enterReceipt": "กรอกข้อมูลใบเสร็จ",
    "receiptTitle": "ข้อมูลใบเสร็จรับเงิน",
    "subscribeRenew": "สมัคร / ต่ออายุแพ็กเกจ",
    "addAdminSeats": "เพิ่มที่นั่งแอดมิน",
    "paidPlanRequired": "ต้องมีแพ็กเกจที่ชำระเงินแล้วก่อนถึงจะเพิ่มที่นั่งได้",
    "renewalSeatsLocked": "แพ็กเกจปัจจุบันมีที่นั่งเสริม +{{count}} ที่นั่ง ระบบจะใช้จำนวนเดิมเมื่อต่ออายุ หากต้องการเพิ่มที่นั่ง ให้ไปที่แท็บ \"เพิ่มที่นั่งแอดมิน\"",
    "bundlePrice": "ราคาพิเศษเมื่อซื้อพร้อมแพ็กเกจ (ปกติ {{price}}/เดือน)",
    "proratedPrice": "คิดราคาตามวันที่เหลือของแพ็กเกจปัจจุบัน",
    "payPromptPay": "ชำระเงินผ่าน PromptPay"
  },
  "planPicker": {
    "ariaLabel": "แพ็กเกจ",
    "oneMonth": "1 เดือน",
    "perMonthRenew": "ต่อเดือน · ต่ออายุก่อนหมดอายุ",
    "totalOnce": "รวม {{total}} จ่ายครั้งเดียวต่อรอบ"
  },
  "addon": {
    "title": "เพิ่มที่นั่งสำหรับแอดมิน",
    "pricePerSeatMonth": "{{price}} ต่อที่นั่งต่อเดือน",
    "seatsAfter": "รวมที่นั่งแอดมินหลังเพิ่ม",
    "seatCount_other": "{{count}} ที่นั่ง"
  },
  "summary": {
    "title": "สรุปคำสั่งซื้อ",
    "basePlan": "แพ็กเกจหลัก",
    "pricePerSeat": "ราคาต่อที่นั่ง",
    "perMonth": "{{price}} / เดือน",
    "seatQuantity": "จำนวนที่นั่ง",
    "daysRemaining": "วันที่เหลือในแพ็กเกจ",
    "dayCount_other": "{{count}} วัน",
    "addonSeats": "ที่นั่งเสริม",
    "renewExisting": "ต่ออายุที่นั่งเดิม {{count}} ที่ × {{price}} × {{days}} วัน",
    "newSeats": "ที่นั่งใหม่ {{count}} ที่ × {{price}} × {{days}} วัน",
    "total": "ยอดรวมทั้งหมด",
    "renewPlan": "ต่ออายุแพ็กเกจ",
    "from": "จาก",
    "to": "ถึง",
    "starts": "วันเริ่มต้น",
    "ends": "วันสิ้นสุด",
    "seatsAfterPayment_other": "หลังชำระเงินจะมีที่นั่งทั้งหมด {{count}} ที่นั่ง"
  },
  "receiptForm": {
    "saved": "บันทึกข้อมูลใบเสร็จแล้ว",
    "companyName": "ชื่อบริษัทตามหนังสือรับรอง",
    "fullName": "ชื่อ-นามสกุล",
    "digits13": "ต้องเป็นตัวเลข 13 หลัก",
    "taxIdRequired": "กรุณากรอกเลขประจำตัวผู้เสียภาษี",
    "individual": "บุคคลธรรมดา",
    "juristic": "นิติบุคคล",
    "nameRequired": "กรุณากรอกชื่อ",
    "taxId": "เลขประจำตัวผู้เสียภาษี (13 หลัก)",
    "headOffice": "สำนักงานใหญ่",
    "branch": "สาขา",
    "branchCode": "รหัสสาขา (5 หลัก)",
    "branchRequired": "กรุณากรอกรหัสสาขา",
    "digits5": "ต้องเป็นตัวเลข 5 หลัก",
    "address": "ที่อยู่สำหรับออกใบเสร็จ",
    "addressRequired": "กรุณากรอกที่อยู่",
    "zipCode": "รหัสไปรษณีย์",
    "zipRequired": "กรุณากรอกรหัสไปรษณีย์",
    "email": "อีเมลสำหรับรับใบเสร็จ",
    "emailRequired": "กรุณากรอกอีเมล",
    "emailInvalid": "รูปแบบอีเมลไม่ถูกต้อง",
    "phone": "เบอร์โทรศัพท์",
    "save": "บันทึกข้อมูลใบเสร็จ"
  },
  "receiptCard": {
    "edit": "แก้ไข",
    "taxIdShort": "เลขประจำตัวผู้เสียภาษี",
    "hint": "ใช้ออกใบเสร็จรับเงินเมื่อชำระค่าแพ็กเกจ การแก้ไขมีผลกับการชำระเงินครั้งถัดไป"
  },
  "history": {
    "title": "ประวัติการสั่งซื้อ",
    "backToPlan": "กลับไปยังแพ็กเกจ",
    "kind": {
      "plan": "แพ็กเกจ",
      "planWithAddon": "แพ็กเกจ + ที่นั่งเพิ่ม",
      "addonOnly": "ที่นั่งเพิ่ม"
    },
    "tabs": {
      "all": "ทั้งหมด",
      "awaitingPayment": "รอชำระ",
      "paid": "ชำระแล้ว",
      "expired": "หมดอายุ",
      "failed": "ไม่สำเร็จ",
      "cancelled": "ยกเลิกแล้ว"
    },
    "empty": {
      "all": "ยังไม่มีคำสั่งซื้อ",
      "awaitingPayment": "ไม่มีคำสั่งซื้อรอชำระ",
      "paid": "ยังไม่มีคำสั่งซื้อที่ชำระแล้ว",
      "expired": "ไม่มีคำสั่งซื้อที่หมดอายุ",
      "failed": "ไม่มีคำสั่งซื้อที่ไม่สำเร็จ",
      "cancelled": "ไม่มีคำสั่งซื้อที่ยกเลิก"
    },
    "cancelTitle": "ยกเลิกคำสั่งซื้อ?",
    "cancelWarning": "ถ้ายกเลิกแล้วและยังจ่ายเงินทีหลัง ระบบจะรับเงินไว้แต่จะไม่ต่ออายุแพ็กเกจให้ คุณจะต้องทำเรื่องคืนเงินกับทีมงาน",
    "confirmCancel": "ยืนยันการยกเลิก",
    "close": "ปิด",
    "cancelledSuccess": "ยกเลิกคำสั่งซื้อแล้ว",
    "viewDetails": "ดูรายละเอียด",
    "continuePayment": "ชำระเงินต่อ",
    "cancelOrder": "ยกเลิกคำสั่งซื้อ",
    "date": "วันที่",
    "type": "ประเภท",
    "status": "สถานะ",
    "amount": "ยอดเงิน",
    "orderMenu": "เมนูคำสั่งซื้อ"
  },
  "status": {
    "awaitingPayment": "รอชำระเงิน",
    "paid": "ชำระแล้ว",
    "expired": "หมดอายุ",
    "failed": "ไม่สำเร็จ",
    "cancelled": "ยกเลิกแล้ว"
  },
  "payment": {
    "notFound": "ไม่พบคำสั่งซื้อ",
    "notFoundDetail": "คำสั่งซื้อนี้อาจถูกลบหรือคุณไม่มีสิทธิ์เข้าถึง",
    "orderExpired": "คำสั่งซื้อหมดอายุ",
    "paymentFailed": "การชำระเงินไม่สำเร็จ",
    "orderCancelled": "คำสั่งซื้อถูกยกเลิก",
    "startNew": "กรุณาเริ่มต้นคำสั่งซื้อใหม่",
    "title": "ชำระเงินผ่าน PromptPay",
    "subtitle": "สแกน QR ด้านล่างจากแอปธนาคารของคุณเพื่อชำระเงิน",
    "instructionsTitle": "วิธีการชำระเงิน",
    "instruction1": "เปิดแอปธนาคาร / Mobile Banking",
    "instruction2": "เลือกเมนูสแกน QR (PromptPay)",
    "instruction3": "สแกน QR ด้านบน",
    "instruction4": "ตรวจสอบยอด แล้วกดยืนยันการชำระเงิน",
    "instruction5": "เมื่อชำระสำเร็จ ระบบจะอัปเดตสถานะอัตโนมัติ",
    "qrMissing": "ไม่พบ QR",
    "qrAltWithAmount": "QR สำหรับชำระเงิน PromptPay จำนวน {{amount}}",
    "qrAlt": "QR สำหรับชำระเงิน PromptPay",
    "qrExpired": "QR หมดอายุแล้ว — กรุณาเริ่มต้นคำสั่งซื้อใหม่",
    "qrExpiresIn": "QR หมดอายุใน {{duration}}"
  },
  "success": {
    "title": "ชำระเงินสำเร็จ",
    "activeUntil": "แพ็กเกจของคุณจะใช้งานได้ถึง {{date}}",
    "updating": "ระบบกำลังอัปเดตสถานะแพ็กเกจของคุณ",
    "goToChat": "ไปที่หน้าหลัก",
    "viewHistory": "ดูประวัติการสั่งซื้อ"
  },
  "detail": {
    "title": "รายละเอียดคำสั่งซื้อ",
    "type": "ประเภท:",
    "monthCount_other": "{{count}} เดือน",
    "seatCount_other": "+{{count}} ที่นั่ง",
    "paidAfterCancel": "เงินเข้าหลังยกเลิก",
    "paidAfterCancelDetail": "คำสั่งซื้อนี้ถูกยกเลิกแล้ว แต่ระบบได้รับการชำระเงิน",
    "contactRefund": "ติดต่อ LINE OA เพื่อขอคืนเงิน",
    "timeline": "ไทม์ไลน์",
    "createdAt": "สร้างเมื่อ",
    "paidAt": "ชำระเงินเมื่อ",
    "expiredAt": "หมดอายุเมื่อ",
    "cancelledAt": "ยกเลิกเมื่อ",
    "downloadReceipt": "ดาวน์โหลดใบเสร็จ",
    "receiptFailed": "ออกใบเสร็จไม่สำเร็จ",
    "receiptFailedDetail": "ระบบไม่สามารถออกใบเสร็จอัตโนมัติได้ กรุณาติดต่อทีมงานเพื่อตรวจสอบ",
    "receiptPending": "กำลังออกใบเสร็จรับเงิน",
    "discount": "ส่วนลด",
    "regularPrice": "ราคาปกติ ({{price}} × {{count}} เดือน)",
    "discountPercent": "ส่วนลด {{percent}}%",
    "actualPaid": "จ่ายจริง"
  },
  "renew": {
    "expired": "แพ็กเกจหมดอายุ —",
    "buy": "ซื้อแพ็กเกจ",
    "continue": "เพื่อใช้งานต่อ"
  },
  "failure": {
    "insufficientFunds": "ยอดเงินในบัญชีไม่เพียงพอ",
    "expired": "QR หมดอายุก่อนชำระเงิน",
    "cancelled": "การชำระเงินถูกยกเลิก",
    "declined": "ธนาคารปฏิเสธการชำระเงิน",
    "riskDeclined": "ธนาคารปฏิเสธการชำระเงินด้วยเหตุผลด้านความปลอดภัย",
    "timeout": "ธุรกรรมใช้เวลานานเกินไป",
    "unknown": "การชำระเงินไม่สำเร็จ · ติดต่อ LINE OA {{lineId}}"
  },
  "errors": {
    "subscriptionExpiredTitle": "แพ็กเกจหมดอายุ",
    "subscriptionExpired": "สมัครแพ็กเกจเพื่อใช้งานต่อ",
    "subscribe": "สมัครแพ็กเกจ",
    "addonDecrease": "ไม่สามารถลดที่นั่งเสริมผ่านการต่ออายุได้ กรุณาเลือกจำนวนเท่าเดิมหรือมากกว่า",
    "cartChanged": "ตะกร้ามีการเปลี่ยนแปลง กรุณาลองอีกครั้ง",
    "pendingTitle": "มีคำสั่งซื้อรอชำระ",
    "pendingDetail": "ชำระหรือยกเลิกคำสั่งซื้อที่ค้างอยู่ก่อนสร้างใหม่",
    "viewOrders": "ไปดูคำสั่งซื้อ",
    "persistTitle": "ระบบบันทึกคำสั่งซื้อไม่สำเร็จ",
    "persistDetail": "ทีมงานได้รับแจ้งแล้ว กรุณาอย่าชำระเงินซ้ำ · ติดต่อ LINE OA {{lineId}}",
    "acknowledge": "เข้าใจแล้ว",
    "addonRequiresPlan": "ต้องมีแพ็กเกจที่ชำระเงินแล้วก่อนซื้อที่นั่งเพิ่ม",
    "provider": "ระบบชำระเงินขัดข้อง กรุณาลองอีกครั้งภายหลัง",
    "invalidTotal": "ยอดคำสั่งซื้อไม่ถูกต้อง",
    "loadPlans": "ไม่สามารถโหลดแพ็กเกจได้",
    "calculatePrice": "ไม่สามารถคำนวณราคาได้",
    "connectServer": "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้",
    "loadOrder": "ไม่สามารถโหลดคำสั่งซื้อได้",
    "cancelOrder": "ยกเลิกคำสั่งซื้อไม่สำเร็จ",
    "downloadReceipt": "ดาวน์โหลดใบเสร็จไม่สำเร็จ",
    "loadReceipt": "ไม่สามารถโหลดข้อมูลใบเสร็จได้",
    "saveReceipt": "บันทึกข้อมูลใบเสร็จไม่สำเร็จ"
  }
}
